import { httpClient } from "@/service/http_client";
export class SaveContainerService {
  async saveContainers(url: string, payload: any): Promise<any> {
    const response = await httpClient.post(url, payload);
    try {
      if (response.statusCode >= 400) {
        throw Error(response.status);
      } else {
        return response.containers;
      }
    } catch (error) {
      throw Error(response.status);
    }
  }
}
